<template>
  <div class="wrapper">
    <div
      class="nav"
      :class="{ fixed: isnav }"
      unselectable="on"
      onselectstart="return false;"
      style="-moz-user-select:none;"
    >
      <div class="left" @click="gotopath('/cn')">
        <img src="/static/img/logo-blue.png" alt="" />
      </div>
      <div class="right">
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/cn' }"
          @click="gotopath('/cn')"
          >首页
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/cn/robor' }"
          @click="gotopath('/cn/robor')"
          >蓝鲨 R 系列
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/cn/h1' }"
          @click="gotopath('/cn/h1')"
          >蓝鲨 H 系列
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/cn/story' }"
          @click="gotopath('/cn/story')"
          >蓝鲨故事
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/cn/news' }"
          @click="gotopath('/cn/news')"
          >蓝鲨新闻
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/cn/video' }"
          @click="gotopath('/cn/video')"
          >蓝鲨视频
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/cn/contactus' }"
          @click="gotopath('/cn/contactus')"
          >联系我们
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/cn/support' }"
          @click="gotopath('/cn/support')"
          >服务支持
        </span>
        <span
          class="navbtn"
          :class="{ navactive: cupath == '/cn/app' }"
          @click="gotopath('/cn/app')"
          >蓝鲨 App
        </span>
        <span
          class="lan"
          @mouseover="islanlist = true"
          @mouseleave="islanlist = false"
        >
          <span class="sl">Select Language</span>
          <img
            class="picker"
            :class="{ reserve: islanlist }"
            src="/static/img/tobottom.png"
            alt=""
          />
          <div class="lanlist" v-show="islanlist">
            <div class="language firstlan" @click="gotopath('/cn')">
              简体中文
            </div>
            <div class="language" @click="gotopath('/tc')">繁體中文</div>
            <div class="language" @click="gotopath('/en')">English</div>
            <div class="language" @click="gotopath('/kr')">한국어</div>
          </div>
        </span>
      </div>
    </div>
    <router-view @shownav="shownav" @hidenav="hidenav"></router-view>
    <div class="footer">
      <div class="fleft">
        <!-- <div class="homelogo"></div>
        <div class="homeline">|</div>
        <div class="hometitle">Ride the tide.</div> -->
      </div>
      <div class="fright">
        <div class="record">
          © 2019 blueshark.com All rights reserved.
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >沪ICP备18039357号-1</a
          >
        </div>
        <div
          class="wxlogo"
          @mouseover="iswxcode = true"
          @mouseleave="iswxcode = false"
        >
          <img
            src="/static/img/wx.png"
            alt="扫码关注蓝鲨智能电动摩托车微信公众号"
            style="width:100%"
          />
          <div class="wxcodelogo" v-show="iswxcode">
            <img
              src="/static/img/wxcode.png"
              alt="扫码关注蓝鲨智能电动摩托车微信公众号"
              style="width:100%"
            />
          </div>
        </div>
        <div class="wblogo" @click="toWb('https://weibo.com/u/6777970326')">
          <img
            src="/static/img/wb.png"
            alt="扫码关注蓝鲨智能电动摩托车微博"
            style="width:100%"
          />
        </div>
        <!-- <div class="wblogo" @click="toLink('https://global.blueshark.com')"><img src="/static/img/global.png" alt="Blueshark global" style="width:100%"></div> -->
      </div>
    </div>
    <div class="totop" v-show="istotop" @click="toTop"></div>
  </div>
</template>

<script>
const smoothscroll = () => {
  let top =
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    window.pageYOffset
  if (top > 0) {
    requestAnimationFrame(smoothscroll)
    window.scrollTo(0, top - top / 5)
  }
}

export default {
  data() {
    return {
      isnav: false,
      istotop: false,
      islanlist: false,
      iswxcode: false,
      cupath: '/'
    }
  },
  mounted() {
    document.title = '蓝鲨智能摩托'
    this.cupath = this.$route.path
    // console.log(this.cupath,"pathc")
  },
  watch: {
    '$route.path'(newval, oldval) {
      this.cupath = newval
    }
  },
  methods: {
    // product
    shownav() {
      this.isnav = true
      this.istotop = true
    },
    hidenav() {
      this.isnav = false
      this.istotop = false
    },
    // contactus
    showfooter() {
      this.isfooter = true
    },
    hidefooter() {
      this.isfooter = false
    },
    // common
    gotopath(path) {
      this.$router.push(path)
    },
    toLink(path) {
      location.href = path
    },
    toTop() {
      smoothscroll()
    },
    toWb(e) {
      window.open(e)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  .nav {
    position: absolute;
    z-index: 100;
    left: 0;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    padding: 15px 50px;
    height: 60px;
    line-height: 30px;
    box-sizing: border-box;
    .left {
      cursor: pointer;
      img {
        width: 120px;
        vertical-align: middle;
      }
    }
    .right {
      text-align: right;
      position: relative;
      .navbtn {
        color: #fff;
        padding: 0 20px;
        cursor: pointer;
        transition: color 0.3s;
      }
      .navbtn:hover {
        color: #0092f3;
      }
      .navactive {
        color: #0092f3;
      }
      .lan {
        color: #fff;
        display: inline-block;
        width: 150px;
        text-align: center;
        cursor: pointer;
        margin-left: 15px;
        border-left: 1px solid #666;
        .picker {
          width: 12px;
          position: relative;
          margin-left: 10px;
          top: -2px;
          transition: transform 0.3s;
        }
        .reserve {
          transform: rotate(180deg);
        }
        .sl {
          font-size: 12px;
        }
      }
      .lanlist {
        color: #fff;
        position: absolute;
        z-index: 5;
        width: 150px;
        padding: 20px 0;
        top: 25px;
        text-align: left;
        background: rgba(0, 0, 0, 0.7);
        .language {
          cursor: pointer;
          transition: color 0.3s;
          width: 100px;
          margin: 0 auto;
          line-height: 16px;
          padding-top: 15px;
          font-size: 14px;
        }
        .firstlan {
          border-top: 1px solid #666;
        }
        .language:hover {
          color: #0092f3;
        }
      }
    }
  }
  .fixed {
    position: fixed;
    background: rgba(0, 0, 0, 0.7);
    animation: navani 1s;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 120px;
    padding: 0 50px;
    background: #000;
    .fleft {
      width: 288px;
      height: 24px;
      background: url('/static/img/home-logo.png') no-repeat;
      background-size: 100%;
    }
    .fright {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .record {
        color: #333;
        font-size: 14px;
        a {
          color: #333;
          font-size: 14px;
          text-decoration: none;
        }
      }
      .wxlogo {
        position: relative;
        padding: 5px;
        width: 16px;
        height: 13px;
        margin-left: 10px;
        opacity: 0.8;
        .wxcodelogo {
          position: absolute;
          width: 80px;
          height: 86px;
          top: -86px;
          left: -29px;
        }
        // background: url('/static/img/wx.png') no-repeat;
        //  background-size: 100%;
      }
      .wxlogo:hover {
        opacity: 1;
      }
      .wblogo {
        opacity: 0.8;
        cursor: pointer;
        padding: 5px;
        width: 16px;
        height: 13px;
        // margin-left: 10px;
        // background: url('/static/img/wb.png') no-repeat;
        //  background-size: 100%;
      }
      .wblogo:hover {
        opacity: 1;
      }
    }
  }
  // .footer{
  //   padding: 5vw 5vw 2vw;
  //   background-color: #000;
  //   color: #999;
  //   text-align: center;
  //   font-size: 14px;
  //   .f_top{
  //     display: flex;
  //     display: -webkit-flex;
  //     height: 24px;
  //     line-height: 24px;
  //     margin-bottom: 3vw;
  //     .ft_left{
  //       flex: 1;
  //       text-align: right;
  //       border-right: 1px solid #333;
  //       padding-right: 20px;
  //       img{
  //         vertical-align: top;
  //         width: 130px;
  //       }
  //     }
  //     .ft_right{
  //       text-align: left;
  //       font-size: 20px;
  //       padding-left: 20px;
  //       color: #0092f3;
  //       flex: 1;
  //     }
  //   }
  //   .f_middle{
  //     display: flex;
  //     display: -webkit-flex;
  //     .fm_left{
  //       text-align: right;
  //       margin-right: 30px;
  //       flex: 1;
  //     }
  //     .fm_right{
  //       text-align: left;
  //       flex: 1;
  //     }
  //     .fm_content{
  //       font-size: 12px;
  //       line-height: 24px;
  //       margin-top: 10px;
  //     }
  //     .blank{
  //       display: inline-block;
  //       width: 25px;
  //     }
  //     .blank0{
  //       display: inline-block;
  //       width: 35px;
  //     }
  //     .blank1{
  //       display: inline-block;
  //       width: 60px;
  //     }
  //     .blank2{
  //       display: inline-block;
  //       width: 50px;
  //     }
  //     img{
  //       width: 100px;
  //     }
  //   }
  //   .f_bottom{
  //     font-size: 14px;
  //     margin-top: 3vw;
  //     padding-top: 2vw;
  //     border-top: 1px solid #333;
  //   }
  // }
  .totop {
    position: fixed;
    z-index: 100;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
  }
  .totop::before {
    position: absolute;
    content: '';
    width: 8px;
    height: 8px;
    top: 10px;
    left: 10px;
    margin: auto;
    border-top: 3px solid #999;
    border-right: 3px solid #999;
    transform: rotate(-45deg);
  }
}
@keyframes navani {
  from {
    top: -60px;
  }
  to {
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cn/index.vue